import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { first } from 'rxjs/internal/operators/first';
import { CreateAccountConstants } from '../create-account/constants/create-account.const';
import { RouterConstants } from '../../../core/routing/constants/app-paths.constant';
import { CreateAccountService } from '../../../core/routing/services/createAccount/create-account.service';
import { ConfirmRegistrationConstants } from './constants/confirm-registration.constant';

@Component({
  selector: 'iposcen-confirm-registration',
  templateUrl: './confirm-registration.component.html',
  styleUrls: ['./confirm-registration.component.scss']
})
export class ConfirmRegistrationComponent implements OnInit, OnDestroy {

  confirmationCode: string;
  regForm: FormGroup;
  email: string;
  modalTitle: string;
  modalBody: string;
  errorMessage: string;
  loginhref: string;
  closeResult: string;
  modalDiv: string;
  button: string;
  heading: string;
  code: string;
  resend: string;
  firstName: string;
  login: string;
  accountReq: string;
  accountCreated: string;
  emailNotification: string;
  cnfMsgApproved: string;
  cnfMsgUnapproved: string;
  mailSent: string;
  alertFormat: string;
  isApprovedDomain: boolean;
  isInVaildCode: boolean;
  placeholderConfirmationCode: string;
  approvedDomainList: string[] = [];
  msgNotifyList: any;
  private sub: any;
  private ngUnsubscribe = new Subject<boolean>();
  constructor(public service: CreateAccountService,
    public router: Router,
    public route: ActivatedRoute,
    public formbuilder: FormBuilder,
    public modalService: NgbModal) {
  }

  ngOnInit() {
    this.loginhref = RouterConstants.LOGIN_PAGE_LINK;
    this.firstName = sessionStorage.getItem('firstName');
    this.emailNotification = sessionStorage.getItem('email');
    this.placeholderConfirmationCode = ConfirmRegistrationConstants.PLACEHOLDER_CONFIRMATION_CODE;   
    this.resend = ConfirmRegistrationConstants.RESEND_CODE;
    this.login = ConfirmRegistrationConstants.LOGIN;
    this.code = ConfirmRegistrationConstants.CONF_CODE;
    this.heading = ConfirmRegistrationConstants.CONF_REG_HEADING;
    this.button = ConfirmRegistrationConstants.CONFIRM_BUTTON;
    this.isInVaildCode = false;
    this.sub = this.route.params.subscribe(params => {
      this.email = params.email;
      this.regForm = this.formbuilder.group({
        confirmationCode: new FormControl('', [Validators.required])
      });

    });

    this.errorMessage = undefined;
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  onConfirmRegistration(): void {
    this.errorMessage = undefined;
    this.confirmationCode = this.regForm.get('confirmationCode').value;
    const userId = sessionStorage.getItem('userId');
    const confirmRegRequestData = {
      confirmationCode: this.confirmationCode.trim(),
      email: this.email,
      userID: userId
    };
    //account registration for both non-connected and connected user
    this.service.confirmAccountRegistration(confirmRegRequestData)
    .pipe(takeUntil(this.ngUnsubscribe))
    .pipe(first())
      .subscribe(createAccountResponse => {
        if (createAccountResponse.user.userStatus === CreateAccountConstants.CREATED_USER_STATUS_ACTIVE) {
          this.router.navigate([RouterConstants.ACCOUNT_CREATED_LINK, ConfirmRegistrationConstants.CREATED_USER_STATUS_ACTIVE]);
        } else {
          this.router.navigate([RouterConstants.ACCOUNT_CREATED_LINK, ConfirmRegistrationConstants.CREATED_USER_STATUS_PENDING]);
        }
        window['dataLayer'].push({
          'account_requested': true
      });
    },
        error => {
          if (error.responseContext.exceptionResponse) {
            this.alertFormat = 'alert alert-danger';
            this.isInVaildCode = true;
            this.errorMessage = error.responseContext.exceptionResponse.errorDetails;
            if (this.errorMessage = 'Please provide a valid Confirmation Code') {
              this.errorMessage = ConfirmRegistrationConstants.INCORRECT_CONFIRMATION_CODE;
            }
          }
      }
    );

    //gtm(Google tag manager)
    window['dataLayer'].push({
      'confirm_account_by_enduser':true
      });
  }

  resendCode(): void {
    this.service.resendCode(this.email, this);
  }

  cognitoCallback(message: string, result: any) {
    if (message !== undefined) { // error
      this.alertFormat = 'alert alert-danger';
      if (message === ConfirmRegistrationConstants.CODE_RESENT) {
        this.alertFormat = 'alert alert-secondary';
        this.isInVaildCode = false;
      } else {
        this.isInVaildCode = true;
      }
      this.errorMessage = message;

    } else {
      this.router.navigateByUrl(RouterConstants.ACCOUNT_CREATED_LINK);
    }
  }

}
